import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { ShieldIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const privacySettingsDefinition: SmartSignalDefinition<{ privacy_settings?: IdEventV4['privacy_settings'] }> = {
  key: 'privacy-settings',
  label: 'Privacy settings',
  extract: (e) => ({ privacy_settings: e.privacy_settings }),
  icon(e) {
    const p = this.extract(e)?.privacy_settings
    return (
      <ShieldIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.privacy_settings
    return p === true
  },
  isWeb: () => true,
  isMobile: () => false,
  searchFor: '"privacy_settings":',
  documentationHash: '#privacy-focused-settings',
  urlParamKey: IdentificationUrlKeys.PrivacySettings,
}
